import { Directive,  } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { InputCheckersService, SharedDataService, SuppliersService } from '../all-services';
import { Observable, of } from 'rxjs';
import {  SimpleReponseResult } from '../all-models';
import { map } from 'rxjs/operators';

@Directive({
  selector: '[siretSiege]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: SiretSiegeDirective, multi:
      true
  }]
})
export class SiretSiegeDirective  implements AsyncValidator {

  constructor(
    public sharedDatasSvc:SharedDataService,
    private suppliersSvc:SuppliersService,
    private inputCheckersSvc: InputCheckersService) { }
  private msg:string;



  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    const siret=(<string>control.value || '').replace(/\s/g, '');
    if ((control.value||'null')=='null') return of(null);
    if (siret.length<14) return of(null);
    return this.inputCheckersSvc.SiretSiegeValidate(siret)
      .pipe(map((result:SimpleReponseResult)=> {
        if (result.Ok && !result.Message) {
          return null;
        } else if (result.Ok) {
          return {'siretSiegeWarning': result};
        } else {
          return {'siretSiegeError': result};
        }
      }));
  }


  registerOnValidatorChange?(fn: () => void): void {
    
  }
}
